import { Request as BaseRequest } from '../components/Utils';
import { baseUrl, bucketName } from '../httpService/API';
import { ossSignUrl } from './grt/upload';

export enum UploadType {
    // eslint-disable-next-line no-unused-vars
    UNSET,
    // eslint-disable-next-line no-unused-vars
    VIDEO = 2,
    // eslint-disable-next-line no-unused-vars
    AUDIO = 3
}
export type { RequestResult } from '../components/Utils';
export const obsSignUrl: string = ossSignUrl,
    fileDetail: string = '/user/ai/trans/v1/getDocumentPlayInfo',
    aiDetail: string = '/open/ai/getDetailInfo',
    updateTitle: string = '/user/ai/trans/v1/updateTitle', //修改文件名称
    getTranslation: string = '/user/ai/trans/v1/translation', //翻译
    getTranslationStatus: string = '/user/ai/trans/v1/getTranslationStatus', //翻译
    getDelete: string = '/user/ai/trans/v1/delete'; //（批量）删除资源文件

export class Request extends BaseRequest {
    static baseUrl: string = baseUrl + '/grt-user-center-service';

    static getBucketName(type: UploadType): string {
        if (type === 2 || type === 3) return bucketName['video'];
        return bucketName['other'];
    }

    static getOssBucketName(type: UploadType = UploadType.VIDEO) {
        if (type === UploadType.VIDEO || type === UploadType.AUDIO) return bucketName['oss'];
        return bucketName['other'];
    }

    static getBbsBucketName() {
        return bucketName['other'];
    }
}
